import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import {
  REFERRALOUTCOME_TABLE,
  BOPINSTITUTION_TABLE,
  DRUGAFTERCAREPROGRAMS_TABLE,
  GANGAFFILIATIONS_TABLE,
  REFERRALSOURCE_TABLE,
                                  // BHTsINSURANCEPROVIDERS_TABLE,
} from "actions/action-constants";
import AddEditViewReferral from "./add-edit-view-referral";
// import AddEditViewReferral from './add-edit-view-referral-hooks';
import CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS from "components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS";
class ReferralEditRoot extends Component {
  static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS;
  componentDidMount() {
    const c_USER = this.context;
    this.props.getReferral(this.props.match.params.id);
    this.props.getPrograms(c_USER.id);
    var paramsRO = { tablename: REFERRALOUTCOME_TABLE };
    this.props.getReferralOutcomes(paramsRO);
    var paramsRS = { tablename: REFERRALSOURCE_TABLE };
    this.props.getReferralSources(paramsRS);
                                                          // var paramsBHTs = { 'tablename': BHTsINSURANCEPROVIDERS_TABLE }
                                                          //   this.props.getBHTsInsuranceProviders(paramsBHTs);
    var paramsBOPI = { tablename: BOPINSTITUTION_TABLE };
    this.props.getBOPInstitutions(paramsBOPI);
    var paramsDAP = { tablename: DRUGAFTERCAREPROGRAMS_TABLE };
    this.props.getDrugAftercarePrograms(paramsDAP);
    var paramsGA = { tablename: GANGAFFILIATIONS_TABLE };
    this.props.getGangAffiliations(paramsGA);
  }
  render() {
    /*** redirect and send to referrals list screen if id doesnt exist */
    if (this.props.errorInvalidEntry) {
      return <Redirect to="/referrals" />;
    }
    return (
      <div>
        <AddEditViewReferral
          {...this.props}
          loginID={this.context.id}
          referralMode={1}
          editReferralSave={this.props.updateReferralSave}
          editReferralSaveAndClose={this.props.updateReferralSaveAndClose}
          transferReferralToCients={this.props.transferReferral}
          archiveReferral={this.props.archiveReferral}
        />
      </div>
    );
  }
}
export default withRouter(ReferralEditRoot);
